import { FormattedText, SpanTag } from "@tm/static";
import { theme } from "@tm/utility/global";
import { Card, CardPadding } from "../../OrderDetailV2.style";
import type { OrderDetailV2PriceBreakupProps } from "../../types";
import {
  BreakupItem,
  BreakupSection,
  ExtraChargesSection,
  FinalAmountSection,
  PriceBreakupContainer,
  PriceBreakupTitle,
} from "./OrderDetailV2PriceBreakup.style";

export const OrderDetailV2PriceBreakup = ({
  title,
  breakupList,
  extraCharges,
  finalAmount,
}: OrderDetailV2PriceBreakupProps) => {
  return (
    <Card>
      <CardPadding>
        <PriceBreakupTitle>
          <SpanTag fontWeight="bold" fontSize="md">
            <FormattedText value={title} />
          </SpanTag>
        </PriceBreakupTitle>

        <PriceBreakupContainer>
          {/* Breakup List Section */}
          {breakupList.length > 0 && (
            <BreakupSection>
              {breakupList.map((item, index) => (
                <BreakupItem key={`breakup-${index}`}>
                  <FormattedText
                    value={item.label}
                    baseStyle={{
                      fontWeight: item.style?.fontWeight || "400",
                      fontSize: item.style?.fontSize
                        ? `${item.style.fontSize}px`
                        : "12px",
                      color: item.style?.color || theme.blackText,
                      flex: 1,
                      minWidth: 0,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  />
                  <FormattedText
                    value={item.value}
                    baseStyle={{
                      fontWeight: item.style?.fontWeight || "400",
                      fontSize: item.style?.fontSize
                        ? `${item.style.fontSize}px`
                        : "12px",
                      textAlign: "right",
                      flexShrink: 0,
                      marginLeft: "auto",
                    }}
                  />
                </BreakupItem>
              ))}
            </BreakupSection>
          )}

          {/* Extra Charges Section */}
          {extraCharges.length > 0 && (
            <ExtraChargesSection>
              {extraCharges.map((item, index) => (
                <BreakupItem key={`extra-${index}`}>
                  <FormattedText
                    value={item.label}
                    baseStyle={{
                      fontWeight: item.style?.fontWeight || "400",
                      fontSize: item.style?.fontSize
                        ? `${item.style.fontSize}px`
                        : "14px",
                      color: item.style?.color || theme.blackText,
                      flex: 1,
                      minWidth: 0,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  />
                  <FormattedText
                    value={item.value}
                    baseStyle={{
                      fontWeight: item.style?.fontWeight || "400",
                      fontSize: item.style?.fontSize
                        ? `${item.style.fontSize}px`
                        : "14px",
                      textAlign: "right",
                      flexShrink: 0,
                      marginLeft: "auto",
                    }}
                  />
                </BreakupItem>
              ))}
            </ExtraChargesSection>
          )}

          {/* Final Amount Section */}
          {finalAmount && (
            <FinalAmountSection>
              <BreakupItem>
                <FormattedText
                  value={finalAmount.label}
                  baseStyle={{
                    fontWeight: finalAmount.style?.fontWeight || "400",
                    fontSize: finalAmount.style?.fontSize
                      ? `${finalAmount.style.fontSize}px`
                      : "16px",
                    color: finalAmount.style?.color || theme.blackText,
                    flex: 1,
                    minWidth: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                />
                <FormattedText
                  value={finalAmount.value}
                  baseStyle={{
                    fontWeight: finalAmount.style?.fontWeight || "400",
                    fontSize: finalAmount.style?.fontSize
                      ? `${finalAmount.style.fontSize}px`
                      : "16px",
                    textAlign: "right",
                    flexShrink: 0,
                    marginLeft: "auto",
                  }}
                />
              </BreakupItem>
            </FinalAmountSection>
          )}
        </PriceBreakupContainer>
      </CardPadding>
    </Card>
  );
};
